module.exports = __webpack_public_path__ + "img/no-data.041503f0.png";